module.exports = __webpack_public_path__ + "img/other_pay_cash.2e5413e7.svg";